import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../lib/api';
import { REMOVE_FROM_BOARD, DESTROY_USER } from './constants';

export const useGetUploadStatus = () => {
  const { data = { demoData: {} } } = useQuery(['getUploader'], () =>
    get('/api/client_admin/users/uploads'),
  );

  return { data };
};

export const useGetTotalUsers = () => {
  const { data = { totalUsers: 0 } } = useQuery(
    ['getTotalUsers'],
    () => get('/api/client_admin/users/total_users'),
    { staleTime: Infinity },
  );

  return { data };
};

export const useGetPopulationSegments = () => {
  const { data = [] } = useQuery(['getPopulationSegments'], () =>
    get('/api/client_admin/population_segments'),
  );

  return data.map(({ name, id }) => ({ value: id, label: name }));
};

export const useGetUsers = ({
  sortBy,
  sortDirection,
  nameQuery,
  isPaginated,
  page,
}) => {
  const limit = 20;
  const baseParams = {
    sort_by: sortBy,
    sort_direction: sortDirection,
    name_query: nameQuery,
  };

  const params = isPaginated ? baseParams : { ...baseParams, limit, page };

  const { data = { users: [] }, isLoading } = useQuery(
    ['getUsers', params],
    () => get('/api/client_admin/users', params),
    {
      keepPreviousData: true,
      refetchInterval: false,
    },
  );

  return { data, isLoading, itemsPerPage: limit };
};

export const createUser = ({ user }) => {
  const data = {
    user: {
      name: user.name,
      email: user.email,
      phone_number: user.phoneNumber,
      is_admin: user.isAdmin,
      employee_id: user.employeeId,
      population_segment_ids: user.populationSegments.map(({ value }) => value),
    },
  };

  return api({
    method: 'post',
    url: '/api/client_admin/users',
    data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const editUser = ({ user, userId }) => {
  const data = {
    user: {
      name: user.name,
      email: user.email,
      phone_number: user.phoneNumber,
      is_admin: user.isAdmin,
      employee_id: user.employeeId,
      population_segment_ids: user.segments.map(segment => segment.value),
    },
  };

  return api.put(`/api/client_admin/users/${userId}`, data);
};

export const deleteUser = ({ userId, deletionType }) => {
  let url;

  if (deletionType === REMOVE_FROM_BOARD) {
    url = `/api/client_admin/users/${userId}/remove_from_board/`;
  } else if (deletionType === DESTROY_USER) {
    url = `/api/client_admin/users/${userId}`;
  }

  return api.delete(url);
};

export const inviteUser = userId => {
  return api.post(`/api/client_admin/users/${userId}/invitation`);
};

export const useDownloadUsers = () => {
  const downloadUsers = () => {
    return api.get('/api/client_admin/users/export');
  };

  return { downloadUsers };
};
